import * as React from 'react';
import { Decimal } from 'decimal.js';
import { Form, Field } from 'formik';
import * as Yup from 'yup';
import decimal from '~/lib/normalize/decimal';
import { MAX_CODE_AMOUNT } from '~/apps/sender/consts';
import { currency } from '~/lib/formatters';

import FormikForm from '~/lib/forms/FormikForm';
import Input from '~/common/controls/Input';
import ModelSelect from '~/common/controls/ModelSelect';


const PaycodeFormSchema = Yup.object().shape({
  amount: decimal()
    .typeError('Amount must be a valid number')
    .required('Required')
    .min(1, 'Code amount must be at least a $1.00')
    .max(MAX_CODE_AMOUNT, `Code amount must be less than $${currency(new Decimal(MAX_CODE_AMOUNT))}`),
  locationId: Yup.string()
                 .nullable(),
  note: Yup.string().nullable(),
});


const PaycodeForm = (props) => {
  const { error, onSubmit, organizations, submitting, initialValues } = props;

  return (
    <FormikForm
      initialValues={initialValues}
      mapPropsToValues={(props) => {
        return {
          amount: '',
        };
      }}
      onSubmit={(data) => onSubmit(PaycodeFormSchema.cast(data))}
      validationSchema={PaycodeFormSchema}
      render={() => {
        return (
          <Form className="form__cont">
            <Field
              name="amount"
              label="Amount"
              type="text"
              component={Input}
              className="input input--bubble input--step input--sign"
              inputStep="1."
              inputSign="$"
            />
            <Field
              name="organizationId"
              label="Organization Restriction"
              component={ModelSelect}
              className="input input--bubble input-step"
              inputStep="2."
              selectHelper={organizations}
            />
            <Field
              name="note"
              label="Notes"
              type="text"
              component={Input}
              className="input input--bubble input-step"
              inputStep="3."
            />

            {error && <div className="form__note">{error}</div>}

            <button className="btn btn--prim btn--lg" disabled={submitting} type="submit">
              Submit
            </button>
          </Form>
        );
      }}
    />
  );
};

export default PaycodeForm;
